module.exports = __webpack_public_path__ + "img/Screenshot-3.6f51cb14.png";